import omitDeep from 'omit-deep-lodash';

type ObjectWithTypename = { __typename?: string };
type Result<T> = Omit<T, '__typename'>;

export const cleanGqlObject = <T extends ObjectWithTypename>(object: T): Result<T> => {
  return omitDeep(object, '__typename') as Result<T>;
};
